import React from 'react';
import { shape, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import SingleCasePage from '../../templates/SingleCasePage';
import data from '../../data/cases/drumster';
import nextCaseData from '../../data/casesThumb/detecht';
import InfoColumnSection from '../../components/InfoColumnSection';
import TitleAndBodySection from '../../components/case/TitleAndBodySection';
import ImageGrid from '../../components/case/ImageGrid';
import SingleImage from '../../components/case/SingleImage';
import MobileAnimationSection from '../../components/MobileAnimationSection';

import variables from '../../styles/variables.module.scss';

const nextCase = {
  title: nextCaseData.title,
  path: nextCaseData.path,
  casebg: nextCaseData.casebg,
  color: nextCaseData.color,
  isWeb: nextCaseData.isWeb,
};

const DrumsterCasePage = ({ location }) => (
  <SingleCasePage
    location={location}
    caseName={data.key}
    data={data}
    nextCase={nextCase}
    quoteData={data.quoteData}
  >
    <Container>
      <Grid container direction="column">
        {
          data.titleBodyData[0] && (
            <TitleAndBodySection
              title={data.titleBodyData[0].title}
              body={data.titleBodyData[0].body}
              justify={data.titleBodyData[1] ? 'flex-end' : 'flex-start'}
            />
          )
        }
      </Grid>
    </Container>
    {
      data.animations && (
        <MobileAnimationSection data={data.animations} />
      )
    }
    {
      data.infoTitle && data.infoBody && (
        <Grid item>
          <InfoColumnSection
            headlineSmall={data.title}
            backgroundColor={variables.carbonBlack}
            title={data.infoTitle}
            body={data.infoBody}
            isCase
          />
        </Grid>
      )
    }
    {
      data.environmentSecond && (
        <SingleImage
          image={data.environmentSecond}
          insideGrid
        />
      )
    }
    {
      data.xtra && (
        <ImageGrid
          images={data.xtra}
          isAndroid={data.isAndroid}
        />
      )
    }
    {
      data.footerBanner && (
        <SingleImage
          image={data.footerBanner}
          isAndroid={data.isAndroid}
          insideGrid={data.footerBanner.insideGrid}
          style={{
            width: '100%',
            margin: 0,
            backgroundColor: variables.athensGrey,
          }}
        />
      )
    }
  </SingleCasePage>
);

DrumsterCasePage.propTypes = {
  location: shape({
    pathname: string,
  }).isRequired,
};

export default DrumsterCasePage;
